var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrowave = function SvgMicrowave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.348 55.028H17.652C7.742 55.028 0 62.66 0 72.57v342.422c0 9.91 7.742 18.055 17.652 18.055h20.516c-.689 2.393-1.084 3.895-1.084 6.036 0 9.911 8.034 17.889 17.944 17.889h53.832c9.91 0 17.944-7.978 17.944-17.889 0-2.143-.395-3.644-1.084-6.036h260.56c-.689 2.393-1.084 3.895-1.084 6.036 0 9.91 8.034 17.889 17.944 17.889h53.832c9.91 0 17.944-7.978 17.944-17.889 0-2.143-.395-3.644-1.084-6.036h20.516c9.91 0 17.652-8.145 17.652-18.055V72.57c0-9.91-7.742-17.542-17.652-17.542m-18.236 342.131H35.888V90.916h440.224z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.009 327.776h-29.907c-9.91 0-17.944 8.034-17.944 17.944s8.034 17.944 17.944 17.944h29.907c9.91 0 17.944-8.034 17.944-17.944s-8.034-17.944-17.944-17.944M358.878 123.215H81.346c-9.91 0-17.944 8.034-17.944 17.944V345.72c0 9.91 8.034 17.944 17.944 17.944h277.533c9.91 0 17.944-8.034 17.944-17.944V141.159c-.001-9.91-8.035-17.944-17.945-17.944m-17.943 204.561H99.29V159.103h241.645z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 430.056,
    cy: 253.225,
    r: 19.906
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.056,
    cy: 193.125,
    r: 19.907
  })));
};
export default SvgMicrowave;